export default __webpack_public_path__ + "static/media/five-star-polish.5b500673.svg";